import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import styled from 'styled-components'
import { ChevronUp } from 'styled-icons/fa-solid/ChevronUp'
import { ChevronDown } from 'styled-icons/fa-solid/ChevronDown'

const bsColor = (bss) => {
  switch (bss) {
    case 'success': return 'rgb(154, 205, 50)'
    case 'info': return 'rgb(30, 144, 255)'
    case 'warning': return '#8a6d3b'
    case 'danger': return 'red'
    default: return 'darkgray'
  }
}
const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid #eee;
  border-left-width: 4px;
  border-left-style: solid;
  border-left-color: ${props => bsColor(props.bsStyle)};
  background-color: #fff;
`
const Addon = styled.div`
  display:inline-block;
  margin-right: 10px;
`

class Banner extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = { open: true }
  }

  handleCollapse = () => this.setState({ open: !this.state.open })

  render() {
    const { title, fontSize, addon, collapse } = this.props

    return (
      <div>
        <Header {...this.props}>
          <div className={`font-size-${fontSize}`}>{title}</div>
          <div>
            {
              !addon ? null :
              addon instanceof Array
              ? addon.map( (n, i) => <Addon key={i}>{n}</Addon>)
              : <Addon>{addon}</Addon>
            }
            {
              collapse && (
                this.state.open
                ? <ChevronUp size={14} onClick={this.handleCollapse} />
                : <ChevronDown size={14} onClick={this.handleCollapse} />
              )
            }
          </div>
        </Header>
        <Collapse className='fade' in={collapse ? this.state.open : true}>
          <div>{this.props.children}</div>
        </Collapse>
      </div>
    )
  }
}

Banner.defaultProps = {
  title: '',
  fontSize: 16,
  collapse: false,
}

Banner.propTypes = {
  bsStyle: PropTypes.string,
  title: PropTypes.string,
  fontSize: PropTypes.number,
  addon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  collapse: PropTypes.bool,
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/widgets/Banner.js